//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
	name: "CustomQuery",
	props: {
		results: Object,
		executeSearch: Function,
		setQuery: Function,
		query: String
	},
	data() {
		return {
			labelText: null,
			submitBtnText: null,
		}
	},
	computed: {
		queryModel: {
			get() {
				return this.query;
			},
			set(val) {
				this.setQuery(val);
			},
		},
	},
	methods: {},
	created() {
		// console.log(this.$root.options);
		this.labelText = this.$root.options.queryLabelText;
		this.submitBtnText = this.$root.options.querySubmitText;
	}
}
